import { render, staticRenderFns } from "./Handled.vue?vue&type=template&id=330ffa28"
import script from "./Handled.vue?vue&type=script&lang=js"
export * from "./Handled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports